import type { OrderListQueryKey, UseOrderListParams } from '../types';

export const getOrderListQueryKey = (
  params: UseOrderListParams,
): OrderListQueryKey => ['orders', 'orderList', params];
